import { useState } from 'react';
import OtpInput from 'react18-input-otp';

const RegisterOtpInput = ({ onVerify, isLoading }) => {
  const [OTP, setOTP] = useState('');

  const onOTPChange = (value) => {
    setOTP(value);

    if (value && value.length === 6) {
      onVerify(value);
    }
  };

  return (
    <OtpInput
      isInputNum
      shouldAutoFocus
      autoComplete="true"
      value={OTP}
      numInputs={6}
      containerStyle={{ justifyContent: 'center', gap: '.5rem' }}
      inputStyle={{
        width: '45px',
        height: '55px',
        fontSize: '1.5rem',
        borderRadius: '6px',
        border: 'none',
      }}
      onChange={onOTPChange}
      onSubmit={onVerify}
      disabled={isLoading}
    />
  );
};

export default RegisterOtpInput;
